/**
 * Tecno Restore — theme.js
 * JS vanilla, sin dependencias externas. Se carga con `defer`.
 */

document.addEventListener('DOMContentLoaded', function () {
  initMobileMenu();
  initSearchToggle();
  initPredictiveSearch();
  initStickyHeader();
  initCartDrawer();
  initQuantitySelectors();
  initQuickAdd();
  initFreeShippingBar();
  initScrollReveal();
  initProductGallery();
  initProductRecommendations();
  initProductFormSubmit();
  initCartPageRemove();
  initCartPageQuantityValidation();
  initCheckoutGuard();
  initCollectionFilters();
  initVariantSelector();
  initCardTilt();
  initStickyBuyBar();
  initGalleryZoom();
  initAccountForms();
  initAddressCountrySelects();
  initRecentlyViewed();
  initPackBuilder();
  initBulkOrderSelector();
  initRestoreFlow();
  initStatesTabs();
});

/**
 * Selector de variantes (color/talla/capacidad...). Sin esto, elegir una
 * opción distinta no cambiaba qué variante se añadía al carrito: el
 * formulario seguía enviando siempre selected_or_first_available_variant,
 * así que un cliente podía seleccionar "256GB" y acabar comprando la
 * variante por defecto igualmente. Cada variante trae su HTML de precio y
 * de aviso de stock ya renderizados por Liquid (mismo snippet 'price' que
 * el resto del tema) para que el cambio sea idéntico a lo que Liquid
 * generaría — nada de reimplementar el formato de moneda en JS.
 */
function initVariantSelector() {
  var optionsWrapper = document.querySelector('[data-product-options]');
  var variantsScript = document.querySelector('[data-product-variants]');
  if (!optionsWrapper || !variantsScript) return;

  var variants;
  try {
    variants = JSON.parse(variantsScript.textContent);
  } catch (error) {
    console.error(error);
    return;
  }

  var form = document.querySelector('[data-product-form]');
  var idInput = form && form.querySelector('[name="id"]');
  var priceBox = document.getElementById('ProductPrice');
  var priceStickyBox = document.getElementById('ProductPriceSticky');
  var lowStockBox = document.getElementById('ProductLowStock');
  var skuBox = document.getElementById('ProductSku');
  var submitButton = form && form.querySelector('.product__add-to-cart');

  function selectedOptionValues() {
    var fieldsets = optionsWrapper.querySelectorAll('fieldset');
    return Array.from(fieldsets).map(function (fieldset) {
      var checked = fieldset.querySelector('input:checked');
      return checked ? checked.value : null;
    });
  }

  function findVariant() {
    var selected = selectedOptionValues();
    return variants.find(function (variant) {
      return (
        variant.options.length === selected.length &&
        variant.options.every(function (value, i) {
          return value === selected[i];
        })
      );
    });
  }

  function applyVariant(variant) {
    if (!variant) {
      // Combinación de opciones que no existe como variante real.
      if (submitButton) {
        submitButton.disabled = true;
        submitButton.textContent = submitButton.getAttribute('data-unavailable-text') || submitButton.textContent;
      }
      return;
    }

    if (idInput) idInput.value = variant.id;
    if (priceBox) priceBox.innerHTML = variant.priceHtml;
    if (priceStickyBox) priceStickyBox.innerHTML = variant.priceHtml;
    if (lowStockBox) lowStockBox.innerHTML = variant.lowStockHtml || '';

    if (skuBox) {
      if (variant.sku) {
        skuBox.hidden = false;
        var skuValue = skuBox.querySelector('[data-sku-value]');
        if (skuValue) skuValue.textContent = variant.sku;
      } else {
        skuBox.hidden = true;
      }
    }

    if (submitButton) {
      submitButton.disabled = !variant.available;
      submitButton.textContent = variant.available
        ? submitButton.getAttribute('data-available-text') || submitButton.textContent
        : submitButton.getAttribute('data-sold-out-text') || submitButton.textContent;
    }

    if (window.history && window.history.replaceState) {
      var url = new URL(window.location.href);
      url.searchParams.set('variant', variant.id);
      window.history.replaceState({}, '', url);
    }
  }

  optionsWrapper.addEventListener('change', function (event) {
    if (event.target.matches('input[type="radio"]')) {
      applyVariant(findVariant());
    }
  });
}

/**
 * Filtros de colección: cada checkbox envía el formulario de facetas al
 * cambiar (mejora progresiva — sin JS, el <noscript><button> sigue
 * funcionando). En móvil, el panel de filtros se pliega bajo un botón.
 */
function initCollectionFilters() {
  var form = document.getElementById('CollectionFiltersForm');
  if (form) {
    form.addEventListener('change', function (event) {
      if (event.target.matches('[data-filter-checkbox], [data-filter-price]')) {
        form.submit();
      }
    });
  }

  var toggle = document.querySelector('[data-collection-filters-toggle]');
  var filters = document.querySelector('[data-collection-filters]');
  if (!toggle || !filters) return;

  toggle.addEventListener('click', function () {
    var isOpen = filters.classList.toggle('is-open');
    toggle.setAttribute('aria-expanded', isOpen);
  });
}

/**
 * Página de carrito (no el panel lateral): pone a 0 la cantidad de la fila
 * y envía el formulario nativo `{% form 'cart' %}`, reutilizando el mismo
 * mecanismo `updates[]` que ya usa el botón "Actualizar carrito" — sin
 * necesidad de Ajax en esta página.
 */
function initCartPageRemove() {
  document.addEventListener('click', function (event) {
    var button = event.target.closest('[data-cart-page-remove]');
    if (!button) return;

    var row = button.closest('[data-cart-item-key]');
    var input = row && row.querySelector('[data-quantity-input]');
    if (!input) return;

    setRowQuantity(input, 0);
    button.closest('form').submit();
  });
}

/**
 * Intercepta el envío del formulario de compra de la PDP para añadir al
 * carrito por Ajax (sin recargar la página) y abrir el panel lateral,
 * igual que el "quick add" de las tarjetas de producto. Si algo falla
 * (variante agotada entre que se cargó la página y el envío, etc.), se
 * muestra el mensaje de error de Shopify en el propio formulario.
 */
function initProductFormSubmit() {
  var form = document.querySelector('[data-product-form]');
  if (!form) return;

  var submitButton = form.querySelector('.product__add-to-cart');
  var errorBox = form.querySelector('[data-product-form-error]');

  form.addEventListener('submit', function (event) {
    event.preventDefault();

    var variantId = form.querySelector('[name="id"]').value;
    var quantityInput = form.querySelector('[name="quantity"]');
    var quantity = quantityInput ? parseInt(quantityInput.value || '1', 10) : 1;
    var minQuantity = quantityInput ? parseInt(quantityInput.getAttribute('min') || '1', 10) : 1;

    if (errorBox) {
      errorBox.hidden = true;
      errorBox.textContent = '';
    }

    // Mínimo real de lote (custom.cantidad_minima_lote vía el atributo
    // min/data-min-error del input): si el cliente escribe una cantidad
    // menor a mano, se bloquea aquí, antes de llamar a /cart/add.js —
    // el atributo HTML min por sí solo no sirve porque el submit se
    // intercepta con preventDefault más arriba y nunca dispara la
    // validación nativa del navegador.
    if (quantityInput && quantity < minQuantity) {
      quantityInput.value = minQuantity;
      if (errorBox) {
        errorBox.textContent = quantityInput.getAttribute('data-min-error') || errorBox.getAttribute('data-generic-error') || '';
        errorBox.hidden = false;
      }
      return;
    }

    var originalButtonText = submitButton ? submitButton.textContent : '';
    if (submitButton) {
      submitButton.disabled = true;
      submitButton.textContent = submitButton.getAttribute('data-loading-text') || originalButtonText;
    }

    addToCart(variantId, quantity)
      .then(function () {
        openCartDrawer();
      })
      .catch(function (error) {
        console.error(error);
        // El mensaje técnico de Shopify (p. ej. "Cannot find variant") no se
        // muestra nunca al cliente — solo el genérico traducido. El técnico
        // queda en consola para depurar.
        if (errorBox) {
          errorBox.textContent = errorBox.getAttribute('data-generic-error') || '';
          errorBox.hidden = false;
        }
      })
      .finally(function () {
        if (submitButton) {
          submitButton.disabled = false;
          submitButton.textContent = originalButtonText;
        }
      });
  });
}

/**
 * Ficha de producto: clic en una miniatura cambia la imagen principal.
 * Todas las imágenes ya están en el DOM (precargadas por el navegador con
 * loading="lazy" salvo la primera), así que el cambio es instantáneo, sin
 * parpadeo ni petición de red adicional.
 */
function initProductGallery() {
  var gallery = document.querySelector('[data-product-gallery]');
  if (!gallery) return;

  var main = gallery.querySelector('.product-gallery__main');
  var thumbs = Array.from(gallery.querySelectorAll('[data-gallery-thumb]'));
  var images = Array.from(gallery.querySelectorAll('[data-gallery-image]'));
  if (!images.length) return;

  var counterCurrent = gallery.querySelector('[data-gallery-counter-current]');
  var prevButton = gallery.querySelector('[data-gallery-prev]');
  var nextButton = gallery.querySelector('[data-gallery-next]');

  function currentIndex() {
    var active = images.findIndex(function (img) {
      return img.classList.contains('is-active');
    });
    return active === -1 ? 0 : active;
  }

  function goTo(index) {
    var count = images.length;
    var target = ((index % count) + count) % count;

    images.forEach(function (img) {
      img.classList.toggle('is-active', Number(img.getAttribute('data-gallery-image')) === target);
    });
    thumbs.forEach(function (t) {
      var isActive = Number(t.getAttribute('data-gallery-thumb')) === target;
      t.classList.toggle('is-active', isActive);
      t.setAttribute('aria-selected', isActive);
    });
    if (counterCurrent) counterCurrent.textContent = target + 1;
  }

  thumbs.forEach(function (thumb) {
    thumb.addEventListener('click', function () {
      goTo(Number(thumb.getAttribute('data-gallery-thumb')));
    });
  });

  // stopPropagation: los botones viven dentro de .product-gallery__main,
  // que también es el disparador del zoom — sin esto, cada clic en
  // anterior/siguiente abría el zoom a la vez que cambiaba de foto.
  if (prevButton) {
    prevButton.addEventListener('click', function (event) {
      event.stopPropagation();
      goTo(currentIndex() - 1);
    });
  }
  if (nextButton) {
    nextButton.addEventListener('click', function (event) {
      event.stopPropagation();
      goTo(currentIndex() + 1);
    });
  }

  if (main && images.length > 1) {
    main.addEventListener('keydown', function (event) {
      if (event.key === 'ArrowLeft') { event.preventDefault(); goTo(currentIndex() - 1); }
      if (event.key === 'ArrowRight') { event.preventDefault(); goTo(currentIndex() + 1); }
    });

    // Swipe táctil: umbral de 40px para no confundir un scroll vertical
    // normal de la página con una intención de cambiar de foto.
    var touchStartX = null;
    main.addEventListener('touchstart', function (event) {
      touchStartX = event.touches[0].clientX;
    }, { passive: true });
    main.addEventListener('touchend', function (event) {
      if (touchStartX === null) return;
      var deltaX = event.changedTouches[0].clientX - touchStartX;
      if (Math.abs(deltaX) > 40) {
        goTo(currentIndex() + (deltaX < 0 ? 1 : -1));
      }
      touchStartX = null;
    });
  }

  gallery.__galleryGoTo = goTo;
  gallery.__galleryCurrentIndex = currentIndex;
}

/**
 * Zoom de galería: en un negocio de tecnología reacondicionada, poder
 * inspeccionar de cerca el estado real del producto (marcas, desgaste) es
 * justo lo que más ayuda a decidir la compra — cursor:zoom-in sin zoom
 * real habría sido una promesa rota. Reutiliza las imágenes ya cargadas
 * de la galería principal (hasta 1300px), sin pedir ninguna más grande.
 */
function initGalleryZoom() {
  var trigger = document.querySelector('[data-gallery-zoom-trigger]');
  var overlay = document.querySelector('[data-gallery-zoom]');
  if (!trigger || !overlay) return;

  var zoomImage = overlay.querySelector('[data-gallery-zoom-image]');
  var prevButton = overlay.querySelector('[data-gallery-zoom-prev]');
  var nextButton = overlay.querySelector('[data-gallery-zoom-next]');
  var closeButtons = overlay.querySelectorAll('[data-gallery-zoom-close]');
  var mainImages = Array.from(document.querySelectorAll('[data-gallery-image]'));
  var thumbs = Array.from(document.querySelectorAll('[data-gallery-thumb]'));

  function currentIndex() {
    var active = mainImages.find(function (img) {
      return img.classList.contains('is-active');
    });
    return active ? Number(active.getAttribute('data-gallery-image')) : 0;
  }

  function showIndex(index) {
    var image = mainImages[index];
    if (!image) return;
    zoomImage.src = image.src;
    zoomImage.alt = image.alt;
    if (thumbs[index]) thumbs[index].click();
  }

  function open() {
    showIndex(currentIndex());
    overlay.hidden = false;
  }

  function close() {
    overlay.hidden = true;
  }

  trigger.addEventListener('click', open);
  trigger.addEventListener('keydown', function (event) {
    if (event.key === 'Enter' || event.key === ' ') {
      event.preventDefault();
      open();
    }
  });

  closeButtons.forEach(function (button) {
    button.addEventListener('click', close);
  });

  document.addEventListener('keydown', function (event) {
    if (overlay.hidden) return;
    if (event.key === 'Escape') close();
    if (event.key === 'ArrowLeft' && prevButton) prevButton.click();
    if (event.key === 'ArrowRight' && nextButton) nextButton.click();
  });

  if (prevButton) {
    prevButton.addEventListener('click', function () {
      showIndex((currentIndex() - 1 + mainImages.length) % mainImages.length);
    });
  }
  if (nextButton) {
    nextButton.addEventListener('click', function () {
      showIndex((currentIndex() + 1) % mainImages.length);
    });
  }
}

/**
 * Recomendaciones de producto: se piden de forma diferida (solo cuando el
 * bloque entra en el viewport) contra el motor nativo de recomendaciones de
 * Shopify, para no gastar una petición de red en cada visita a la ficha si
 * el usuario no llega a bajar hasta ahí.
 */
function initProductRecommendations() {
  var wrappers = document.querySelectorAll('[data-recommendations-url]');
  if (!wrappers.length) return;

  // Compartido entre los dos bloques (complementa tu compra / también te
  // puede interesar): si el mismo producto ya salió en uno, no se repite
  // en el otro. Se ordena por posición en la página (querySelectorAll ya
  // devuelve los wrappers en orden de documento), así el bloque que está
  // más arriba —normalmente "complementa tu compra"— gana el hueco.
  var shownProductUrls = window.__pdpShownRecommendationUrls || (window.__pdpShownRecommendationUrls = new Set());

  wrappers.forEach(function (wrapper) {
    var targetId = wrapper.getAttribute('data-recommendations-target');
    var target = targetId ? document.getElementById(targetId) : null;
    var url = wrapper.getAttribute('data-recommendations-url');
    if (!target || !url) return;

    function fetchRecommendations() {
      fetch(url)
        .then(function (response) {
          return response.text();
        })
        .then(function (text) {
          var doc = new DOMParser().parseFromString(text, 'text/html');
          var fresh = doc.getElementById(targetId);
          if (!fresh || fresh.textContent.trim() === '') return;

          var cards = fresh.querySelectorAll('.product-card');
          cards.forEach(function (card) {
            var link = card.querySelector('.product-card__link');
            var href = link ? link.getAttribute('href') : null;
            if (href && shownProductUrls.has(href)) {
              card.remove();
            } else if (href) {
              shownProductUrls.add(href);
            }
          });

          // Degradar con elegancia: si tras quitar duplicados ya no queda
          // ningún producto real que mostrar, el bloque entero desaparece
          // en vez de dejar un título "También te puede interesar" vacío.
          if (fresh.querySelectorAll('.product-card').length === 0) {
            target.innerHTML = '';
            return;
          }

          target.innerHTML = fresh.innerHTML;
        })
        .catch(function (error) {
          console.error(error);
        });
    }

    if (!('IntersectionObserver' in window)) {
      fetchRecommendations();
      return;
    }

    var observer = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            fetchRecommendations();
            observer.unobserve(entry.target);
          }
        });
      },
      { rootMargin: '400px 0px' }
    );

    observer.observe(wrapper);
  });
}

/**
 * Revela secciones marcadas con [data-reveal] al entrar en el viewport.
 * Una sola vez por elemento, discreto, y no bloquea el contenido si el
 * usuario tiene prefers-reduced-motion (ver base.css) o si el navegador
 * no soporta IntersectionObserver.
 */
function initScrollReveal() {
  var targets = document.querySelectorAll('[data-reveal]');
  if (!targets.length) return;

  if (!('IntersectionObserver' in window)) {
    targets.forEach(function (el) {
      el.classList.add('is-visible');
    });
    return;
  }

  var observer = new IntersectionObserver(
    function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-visible');
          observer.unobserve(entry.target);
        }
      });
    },
    { threshold: 0.12, rootMargin: '0px 0px -80px 0px' }
  );

  targets.forEach(function (el) {
    observer.observe(el);
  });
}

/**
 * Restore Flow (Home): imagen sticky + barra de progreso + 6 pasos que se
 * activan según entran en el viewport — igual que la versión React de
 * Figma (IntersectionObserver + estado acumulado), sin frameworks.
 * Progresivo: el CSS por defecto ya muestra los 6 pasos completamente
 * legibles (opacity:1); solo cuando este script confirma que puede
 * observar el scroll añade [is-enhanced], que es lo que activa el
 * atenuado/resalte y el relleno de la barra de progreso. Si el navegador
 * no soporta IntersectionObserver, no se añade la clase y el contenido
 * se queda en su estado ya-legible por defecto — no hay estado roto.
 */
function initRestoreFlow() {
  var root = document.querySelector('[data-restore-flow]');
  if (!root || !('IntersectionObserver' in window)) return;

  var steps = Array.prototype.slice.call(root.querySelectorAll('[data-restore-step]'));
  var segments = Array.prototype.slice.call(root.querySelectorAll('[data-restore-progress] span'));
  var label = root.querySelector('[data-restore-label]');
  if (!steps.length) return;

  // Foco único ("spotlight"), no revelado acumulativo: solo el paso que
  // cruza el centro vertical del viewport queda activo (título en verde),
  // los demás vuelven a su peso normal — coincide con el comportamiento
  // verificado en el sistema aprobado (producto-repro.html / figma-home-repro.html),
  // no con un "una vez visto, se queda revelado".
  var activeIndex = -1;

  function paint() {
    steps.forEach(function (step, i) {
      step.classList.toggle('is-active', i === activeIndex);
    });
    segments.forEach(function (seg, i) {
      seg.classList.toggle('is-active', i <= activeIndex);
    });
    if (label && activeIndex > -1) {
      label.textContent = steps[activeIndex].getAttribute('data-restore-step-label') || label.textContent;
    }
  }

  var observer = new IntersectionObserver(
    function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          activeIndex = Number(entry.target.getAttribute('data-restore-step'));
        }
      });
      paint();
    },
    { threshold: 0, rootMargin: '-45% 0px -45% 0px' }
  );

  steps.forEach(function (step) { observer.observe(step); });
  root.classList.add('is-enhanced');
}

function initMobileMenu() {
  var toggle = document.querySelector('[data-mobile-menu-toggle]');
  var menu = document.querySelector('[data-mobile-menu]');
  if (!toggle || !menu) return;

  function setOpen(isOpen) {
    menu.classList.toggle('is-open', isOpen);
    toggle.setAttribute('aria-expanded', isOpen);
    menu.setAttribute('aria-hidden', !isOpen);
  }

  toggle.addEventListener('click', function () {
    setOpen(!menu.classList.contains('is-open'));
  });

  document.addEventListener('keydown', function (event) {
    if (event.key === 'Escape' && menu.classList.contains('is-open')) {
      setOpen(false);
      toggle.focus();
    }
  });
}

/**
 * Cualquier elemento con [data-search-toggle] abre el mismo overlay
 * (uno solo en la página, en el header) — el Home nuevo tiene su propio
 * disparador de búsqueda integrado en la escena, no solo el del header.
 */
function initSearchToggle() {
  var toggles = document.querySelectorAll('[data-search-toggle]');
  var bar = document.querySelector('[data-search-bar]');
  var closeButtons = document.querySelectorAll('[data-search-close]');
  if (!toggles.length || !bar) return;

  var input = bar.querySelector('input[type="search"]');
  var lastToggle = toggles[0];

  function open(trigger) {
    lastToggle = trigger || lastToggle;
    bar.removeAttribute('hidden');
    document.body.classList.add('search-is-open');
    toggles.forEach(function (t) { t.setAttribute('aria-expanded', 'true'); });
    // El foco espera al siguiente frame: hasta que se quita `hidden` el
    // input no es focusable, un focus() inmediato en el mismo tick no
    // hace nada en la mayoría de navegadores. La clase `is-open` espera
    // al mismo frame — es lo que activa la transición de entrada en CSS
    // (overlay entrando con profundidad, no un corte seco).
    requestAnimationFrame(function () {
      bar.classList.add('is-open');
      if (input) input.focus();
    });
  }

  function close() {
    bar.classList.remove('is-open');
    document.body.classList.remove('search-is-open');
    toggles.forEach(function (t) { t.setAttribute('aria-expanded', 'false'); });
    if (lastToggle) lastToggle.focus();
    // `hidden` se aplica cuando termina la transición de salida, no al
    // instante — si no, el overlay desaparecería en seco antes de que la
    // animación llegue a reproducirse. El setTimeout es red de
    // seguridad: si transitionend no llega (o prefers-reduced-motion
    // colapsa la duración a ~0), el overlay igualmente queda oculto.
    var hidden = false;
    function hide() {
      if (hidden) return;
      hidden = true;
      bar.setAttribute('hidden', '');
      bar.removeEventListener('transitionend', hide);
    }
    bar.addEventListener('transitionend', hide);
    setTimeout(hide, 320);
  }

  toggles.forEach(function (toggle) {
    toggle.addEventListener('click', function () {
      if (bar.hasAttribute('hidden')) {
        open(toggle);
      } else {
        close();
      }
    });
  });

  closeButtons.forEach(function (btn) {
    btn.addEventListener('click', close);
  });

  document.addEventListener('keydown', function (event) {
    if (event.key === 'Escape' && !bar.hasAttribute('hidden')) {
      close();
    }
  });
}

/**
 * Buscador propio sobre la Predictive Search API nativa de Shopify
 * (/search/suggest.json) — sin apps, sin librerías. Foto real + precio
 * real + ahorro real (compare_at_price_max, ya viene en el endpoint) +
 * disponibilidad real en cada resultado. El estado del producto (grado,
 * origen) no está en este endpoint — no se inventa, se ve al entrar en
 * la ficha. Soporta teclado completo (↑↓ Enter Esc), cancela peticiones
 * en curso, y separa estados de carga/error/vacío/resultados.
 */
function initPredictiveSearch() {
  var input = document.querySelector('[data-predictive-search-input]');
  var resultsBox = document.querySelector('[data-predictive-search-results]');
  var hint = document.querySelector('[data-search-hint]');
  if (!input || !resultsBox) return;

  var debounceTimer;
  var currentController;
  var activeIndex = -1;
  var lastQuery = '';

  input.addEventListener('input', function () {
    var query = input.value.trim();
    clearTimeout(debounceTimer);
    activeIndex = -1;

    if (query.length < 2) {
      if (currentController) currentController.abort();
      resultsBox.setAttribute('hidden', '');
      resultsBox.innerHTML = '';
      input.setAttribute('aria-expanded', 'false');
      if (hint) hint.hidden = false;
      return;
    }

    if (hint) hint.hidden = true;
    showLoading();

    debounceTimer = setTimeout(function () {
      fetchPredictiveSearch(query);
    }, 250);
  });

  input.addEventListener('keydown', function (event) {
    var items = resultsBox.querySelectorAll('.predictive-search-results__item');
    if (!items.length) return;

    if (event.key === 'ArrowDown') {
      event.preventDefault();
      activeIndex = Math.min(activeIndex + 1, items.length - 1);
      setActiveItem(items);
    } else if (event.key === 'ArrowUp') {
      event.preventDefault();
      activeIndex = Math.max(activeIndex - 1, -1);
      setActiveItem(items);
    } else if (event.key === 'Enter' && activeIndex > -1) {
      event.preventDefault();
      var href = items[activeIndex].getAttribute('href');
      if (href) window.location.href = href;
    }
  });

  function setActiveItem(items) {
    items.forEach(function (item, i) {
      item.classList.toggle('is-active', i === activeIndex);
      if (i === activeIndex) {
        item.scrollIntoView({ block: 'nearest' });
        input.setAttribute('aria-activedescendant', item.id);
      }
    });
    if (activeIndex === -1) input.removeAttribute('aria-activedescendant');
  }

  function showLoading() {
    var text = resultsBox.getAttribute('data-loading-text') || '';
    resultsBox.innerHTML = '<p class="predictive-search-results__status">' + escapeHtml(text) + '</p>';
    resultsBox.removeAttribute('hidden');
    input.setAttribute('aria-expanded', 'true');
  }

  function fetchPredictiveSearch(query) {
    if (currentController) currentController.abort();
    currentController = new AbortController();
    lastQuery = query;

    var url =
      '/search/suggest.json?q=' +
      encodeURIComponent(query) +
      '&resources[type]=product&resources[limit]=6';

    fetch(url, { signal: currentController.signal })
      .then(function (response) {
        if (!response.ok) throw new Error('search request failed');
        return response.json();
      })
      .then(function (data) {
        renderPredictiveResults(data, query);
      })
      .catch(function (error) {
        if (error.name !== 'AbortError') renderError();
      });
  }

  function renderError() {
    if (input.value.trim() !== lastQuery) return;
    var text = resultsBox.getAttribute('data-error-text') || '';
    resultsBox.innerHTML = '<p class="predictive-search-results__status predictive-search-results__status--error">' + escapeHtml(text) + '</p>';
    resultsBox.removeAttribute('hidden');
  }

  function renderPredictiveResults(data, query) {
    if (input.value.trim() !== query) return;
    var products = (data.resources && data.resources.results && data.resources.results.products) || [];

    if (products.length === 0) {
      var emptyText = (resultsBox.getAttribute('data-no-results-text') || '').replace('""', '"' + escapeHtml(query) + '"');
      resultsBox.innerHTML = '<p class="predictive-search-results__status">' + emptyText + '</p>';
      resultsBox.removeAttribute('hidden');
      input.setAttribute('aria-expanded', 'true');
      return;
    }

    var soldOutText = resultsBox.getAttribute('data-sold-out-text') || '';

    var items = products
      .map(function (product, index) {
        var image = product.featured_image ? product.featured_image.url : product.image;
        var price = parseFloat(product.price);
        var compareAt = parseFloat(product.compare_at_price_max);
        var hasSavings = compareAt > price;
        // Truncar, no redondear: el resto del tema calcula el % de ahorro con
        // divided_by de Liquid (división entera, trunca hacia 0). Si aquí se
        // redondeara, el mismo producto podría mostrar un % distinto en el
        // buscador que en la ficha o el catálogo — mismo dato, dos cifras.
        var savingsPercent = hasSavings ? Math.floor(((compareAt - price) / compareAt) * 100) : 0;
        var itemId = 'PredictiveSearchItem' + index;

        return (
          '<a id="' + itemId + '" class="predictive-search-results__item" href="' + product.url + '">' +
            '<span class="predictive-search-results__media">' +
              (image ? '<img src="' + image + '&width=200" width="100" height="100" alt="" loading="lazy">' : '') +
              (hasSavings ? '<span class="predictive-search-results__savings">-' + savingsPercent + '%</span>' : '') +
            '</span>' +
            '<span class="predictive-search-results__info">' +
              '<span class="predictive-search-results__title">' + escapeHtml(product.title) + '</span>' +
              '<span class="predictive-search-results__meta">' +
                '<span class="predictive-search-results__price">' + formatMoney(product.price) + '</span>' +
                (hasSavings ? '<span class="predictive-search-results__compare-at">' + formatMoney(product.compare_at_price_max) + '</span>' : '') +
                (product.available === false ? '<span class="predictive-search-results__soldout">' + escapeHtml(soldOutText) + '</span>' : '') +
              '</span>' +
            '</span>' +
          '</a>'
        );
      })
      .join('');

    var viewAllLabel = resultsBox.getAttribute('data-view-all-text') || 'Ver todos los resultados';
    var viewAllUrl = '/search?q=' + encodeURIComponent(query);

    resultsBox.innerHTML =
      '<div class="predictive-search-results__list">' + items + '</div>' +
      '<a class="predictive-search-results__view-all" href="' + viewAllUrl + '">' + escapeHtml(viewAllLabel) + '</a>';
    resultsBox.removeAttribute('hidden');
    input.setAttribute('aria-expanded', 'true');
  }

  function formatMoney(value) {
    var num = parseFloat(value);
    if (isNaN(num)) return '';
    return '€' + num.toFixed(2).replace('.', ',');
  }

  function escapeHtml(text) {
    var div = document.createElement('div');
    div.textContent = text || '';
    return div.innerHTML;
  }
}

/**
 * Añade sombra al header cuando hay scroll, para separarlo visualmente del
 * contenido sin perder altura fija (evita layout shift).
 */
function initStickyHeader() {
  var header = document.querySelector('[data-site-header]');
  if (!header) return;

  var ticking = false;

  window.addEventListener(
    'scroll',
    function () {
      if (ticking) return;
      ticking = true;
      requestAnimationFrame(function () {
        header.classList.toggle('is-scrolled', window.scrollY > 8);
        ticking = false;
      });
    },
    { passive: true }
  );
}

/**
 * Carrito: el panel lateral es una sección Liquid (sections/cart-drawer.liquid),
 * no un snippet estático. Tras cualquier mutación (añadir, cambiar cantidad,
 * eliminar) pedimos a Shopify que la vuelva a renderizar en servidor (Ajax
 * Cart API, parámetro `sections`) y sustituimos su HTML entero — así nunca
 * hay drift entre lo que ve el cliente y lo que Shopify considera el
 * carrito real, y no duplicamos el markup del item en JavaScript.
 *
 * Todos los listeners de clic/cambio dentro del carrito usan delegación en
 * `document`, no en los propios elementos: como el panel se sustituye por
 * completo en cada actualización, unos listeners atados a los nodos
 * originales dejarían de funcionar tras el primer cambio.
 */
function initCartDrawer() {
  var openTriggers = document.querySelectorAll('[data-cart-drawer-open]');
  openTriggers.forEach(function (trigger) {
    trigger.addEventListener('click', function (event) {
      event.preventDefault();
      openCartDrawer();
    });
  });

  document.addEventListener('click', function (event) {
    if (event.target.closest('[data-cart-drawer-close]')) {
      closeCartDrawer();
    }
  });

  document.addEventListener('keydown', function (event) {
    if (event.key === 'Escape') closeCartDrawer();
  });
}

function openCartDrawer() {
  var drawer = document.getElementById('CartDrawer');
  if (!drawer) return;
  drawer.classList.add('is-open');
  drawer.setAttribute('aria-hidden', 'false');
}

function closeCartDrawer() {
  var drawer = document.getElementById('CartDrawer');
  if (!drawer) return;
  drawer.classList.remove('is-open');
  drawer.setAttribute('aria-hidden', 'true');
}

/**
 * Selectores de cantidad genéricos (+/-). Si el input pertenece al carrito
 * (data-cart-quantity-input), el cambio dispara una actualización real vía
 * Ajax Cart API. Si no (p. ej. el selector de cantidad de la PDP antes de
 * añadir al carrito), solo cambia el valor local — comportamiento sin red.
 */
/** parseInt de un valor de cantidad, nunca NaN/negativo (texto pegado, campo vacío, etc.) */
function safeQuantity(rawValue, fallback) {
  var parsed = parseInt(rawValue, 10);
  return Number.isNaN(parsed) ? fallback : Math.max(0, parsed);
}

/**
 * La página de carrito (main-cart.liquid) renderiza DOS inputs de
 * cantidad por línea con el mismo name="updates[key]" — uno visible en
 * móvil, otro en escritorio, ocultos por CSS según el ancho — porque
 * cada uno vive en su propio bloque de controles. Sin esto, cambiar la
 * cantidad en el input visible dejaba el otro con el valor antiguo del
 * servidor; al enviar el formulario, Shopify recibía dos valores
 * distintos para la misma línea y el mínimo de lote se podía saltar
 * enviando el duplicado no tocado. Se sincronizan siempre juntos.
 */
function setRowQuantity(input, value) {
  var row = input.closest('[data-cart-item-key]');
  var inputs = row ? row.querySelectorAll('[data-quantity-input]') : [input];
  inputs.forEach(function (el) {
    el.value = value;
  });
}

function showRowError(input, message) {
  var row = input.closest('[data-cart-item-key]');
  var errorEl = row && row.querySelector('[data-quantity-error]');
  if (!errorEl) return;
  errorEl.textContent = message || '';
  errorEl.hidden = !message;
}

function initQuantitySelectors() {
  document.addEventListener('click', function (event) {
    var removeBtn = event.target.closest('[data-cart-item-remove]');
    if (removeBtn) {
      updateCartItemQuantity(removeBtn.getAttribute('data-key'), 0);
      return;
    }

    var decreaseBtn = event.target.closest('[data-quantity-decrease]');
    var increaseBtn = event.target.closest('[data-quantity-increase]');
    if (!decreaseBtn && !increaseBtn) return;

    var selector = (decreaseBtn || increaseBtn).closest('[data-quantity-selector]');
    var input = selector && selector.querySelector('[data-quantity-input]');
    if (!input) return;

    var current = safeQuantity(input.value, 0);
    var min = safeQuantity(input.getAttribute('min'), 1);
    var wanted = current + (increaseBtn ? 1 : -1);
    var value = Math.max(min, wanted);
    setRowQuantity(input, value);
    if (decreaseBtn && wanted < min) {
      showRowError(input, input.getAttribute('data-min-error'));
    } else {
      showRowError(input, null);
    }
    input.dispatchEvent(new Event('change', { bubbles: true }));
  });

  document.addEventListener('change', function (event) {
    if (!event.target.matches('[data-cart-quantity-input]')) return;
    var input = event.target;
    var value = safeQuantity(input.value, 0);
    var min = safeQuantity(input.getAttribute('min'), 0);

    // 0 sigue significando "eliminar la línea" (igual que antes): solo se
    // exige el mínimo cuando el cliente deja el lote en el carrito con
    // una cantidad positiva pero insuficiente.
    if (value > 0 && value < min) {
      value = min;
      showRowError(input, input.getAttribute('data-min-error'));
    } else {
      showRowError(input, null);
    }

    input.value = value;
    updateCartItemQuantity(input.getAttribute('data-key'), value);
  });
}

/**
 * Página de carrito (main-cart.liquid): a diferencia del panel lateral,
 * aquí no hay Ajax por línea — "Actualizar carrito" y "Finalizar compra"
 * son envíos nativos del formulario `{% form 'cart' %}`. El stepper +/-
 * ya respeta el mínimo (mismo listener de initQuantitySelectors), pero
 * escribir un número a mano en el campo no pasaba por ningún filtro:
 * esto valida al cambiar el campo (para dar feedback inmediato) y otra
 * vez al enviar el formulario como red de seguridad, bloqueando el
 * envío si queda algún lote por debajo de su mínimo real.
 */
function initCartPageQuantityValidation() {
  var form = document.querySelector('.cart-page__form');
  if (!form) return;

  function validateInput(input) {
    var min = safeQuantity(input.getAttribute('min'), 0);
    var value = safeQuantity(input.value, 0);

    if (value > 0 && value < min) {
      setRowQuantity(input, min);
      showRowError(input, input.getAttribute('data-min-error'));
      return false;
    }

    setRowQuantity(input, value);
    showRowError(input, null);
    return true;
  }

  form.addEventListener('change', function (event) {
    if (!event.target.matches('[data-quantity-input]')) return;
    validateInput(event.target);
  });

  form.addEventListener('submit', function (event) {
    var inputs = Array.prototype.slice.call(form.querySelectorAll('[data-quantity-input]'));
    var allValid = true;
    inputs.forEach(function (input) {
      if (!validateInput(input)) allValid = false;
    });
    if (!allValid) {
      event.preventDefault();
    }
  });
}

/**
 * Última red de seguridad antes de pasar a checkout: al hacer clic en
 * cualquier enlace "Finalizar compra" (el del panel lateral es un <a>
 * suelto, no un formulario, así que no pasa por initCartPageQuantityValidation
 * ni por el Ajax de updateCartItemQuantity si el cliente edita y navega
 * muy rápido), se relee el carrito real en el servidor (/cart.js, la
 * fuente de verdad, no el DOM) y se compara cada línea contra el mapa de
 * mínimos reales (data-lote-minimums, generado desde
 * custom.cantidad_minima_lote — nunca un número inventado en JS). Si
 * algo no cuadra, se cancela la navegación y se explica por qué en vez
 * de dejar avanzar a un cliente con un lote incompleto en el carrito.
 *
 * Límite conocido y real: esto cubre toda la interacción normal con
 * nuestra tienda (ficha, carrito lateral, página de carrito). No puede
 * impedir que alguien llame directamente a /cart/add.js o /checkout por
 * fuera del theme (curl, consola, JS deshabilitado) — eso exigiría una
 * Shopify Function de validación de carrito/checkout, que requiere plan
 * Shopify Plus (esta tienda es plan Basic, no disponible).
 */
function initCheckoutGuard() {
  var minimumsScript = document.querySelector('[data-lote-minimums]');
  if (!minimumsScript) return;

  var minimums;
  try {
    minimums = JSON.parse(minimumsScript.textContent || '{}');
  } catch (error) {
    minimums = {};
  }
  if (!Object.keys(minimums).length) return;

  document.addEventListener('click', function (event) {
    var link = event.target.closest('[data-checkout-link]');
    if (!link) return;

    event.preventDefault();

    fetch('/cart.js')
      .then(function (response) {
        return response.json();
      })
      .then(function (cart) {
        var invalidItem = cart.items.find(function (item) {
          var rule = minimums[String(item.product_id)];
          return rule && item.quantity < rule.min;
        });

        if (!invalidItem) {
          window.location.href = link.href;
          return;
        }

        var rule = minimums[String(invalidItem.product_id)];
        var errorEl = document.querySelector('[data-checkout-error]');
        if (errorEl) {
          errorEl.textContent = invalidItem.product_title + ': ' + rule.message;
          errorEl.hidden = false;
        }
      })
      .catch(function () {
        // Si /cart.js falla por red, no bloquear la navegación: el
        // formulario de la página de carrito y el Ajax del panel lateral
        // ya validaron el mínimo en su momento.
        window.location.href = link.href;
      });
  });
}

function updateCartItemQuantity(key, quantity) {
  if (!key) return;

  fetch('/cart/change.js', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ id: key, quantity: quantity, sections: 'cart-drawer' }),
  })
    .then(function (response) {
      if (!response.ok) throw new Error('No se pudo actualizar el carrito');
      return response.json();
    })
    .then(function (cart) {
      renderCartDrawerSection(cart, true);
      updateCartCount(cart);
    })
    .catch(function (error) {
      console.error(error);
    });
}

function initQuickAdd() {
  // Delegado en document (no querySelectorAll+addEventListener por botón):
  // el carrito lateral sustituye su <aside id="CartDrawer"> entero por HTML
  // nuevo del servidor en cada cambio (ver renderCartDrawerSection), así
  // que los botones "Añadir" de "combina bien con" son nodos DOM nuevos en
  // cuanto el cliente añade, quita o cambia la cantidad de un producto. Un
  // listener atado directamente al botón original se perdía en ese
  // reemplazo y el botón quedaba muerto al clic. La delegación en document
  // sobrevive a cualquier sustitución de nodos.
  document.addEventListener('click', function (event) {
    var button = event.target.closest('[data-variant-id]');
    if (!button) return;

    var variantId = button.getAttribute('data-variant-id');
    if (!variantId) return;

    var originalText = button.dataset.quickAddOriginalText || button.textContent;
    button.dataset.quickAddOriginalText = originalText;

    button.disabled = true;
    button.textContent = button.getAttribute('data-loading-text') || originalText;
    addToCart(variantId, 1)
      .then(function () {
        button.textContent = originalText;
        openCartDrawer();
      })
      .catch(function (error) {
        console.error(error);
        // Sin panel de error disponible en la tarjeta: el propio botón
        // avisa un momento en vez de fallar en silencio.
        button.textContent = button.getAttribute('data-error-text') || originalText;
        button.classList.add('is-error');
        setTimeout(function () {
          button.textContent = originalText;
          button.classList.remove('is-error');
        }, 2500);
      })
      .finally(function () {
        button.disabled = false;
      });
  });
}

/**
 * Añade una línea al carrito y refresca el panel lateral. Devuelve una
 * promesa con el carrito completo (item_count, total_price, etc.) para que
 * quien llame pueda encadenar su propia UI (p. ej. abrir el drawer).
 */
function addToCart(variantId, quantity) {
  return fetch('/cart/add.js', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ id: variantId, quantity: quantity || 1, sections: 'cart-drawer' }),
  })
    .then(function (response) {
      if (!response.ok) {
        return response.json().then(function (error) {
          throw new Error((error && error.description) || 'No se pudo añadir el producto');
        });
      }
      return response.json();
    })
    .then(function (result) {
      renderCartDrawerSection(result, true);
      return fetch('/cart.js').then(function (r) {
        return r.json();
      });
    })
    .then(function (cart) {
      updateCartCount(cart);
      return cart;
    });
}

/**
 * Sustituye el <aside id="CartDrawer"> completo por el HTML que acaba de
 * renderizar Shopify en servidor para esa misma sección, preservando si
 * estaba abierto (el fragmento recién renderizado siempre viene "cerrado",
 * porque el estado abierto/cerrado es puramente de cliente).
 */
function renderCartDrawerSection(result, keepOpenState) {
  var html = result && result.sections && result.sections['cart-drawer'];
  if (!html) return;

  var current = document.getElementById('CartDrawer');
  if (!current) return;

  var wasOpen = keepOpenState && current.classList.contains('is-open');
  var doc = new DOMParser().parseFromString(html, 'text/html');
  var fresh = doc.getElementById('CartDrawer');
  if (!fresh) return;

  current.replaceWith(fresh);

  if (wasOpen) {
    fresh.classList.add('is-open');
    fresh.setAttribute('aria-hidden', 'false');
  }

  initFreeShippingBar();
}

/**
 * Añade varias líneas al carrito en una sola petición (usa el mismo
 * endpoint /cart/add.js que addToCart, pero con el payload {items: [...]}
 * que Shopify acepta para altas múltiples) y refresca el panel lateral,
 * igual que addToCart. La usa "Arma tu pack" (initPackBuilder) para que
 * el producto principal y los complementos marcados entren en el carrito
 * de una vez, no en N peticiones separadas.
 */
function addMultipleToCart(items) {
  return fetch('/cart/add.js', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ items: items, sections: 'cart-drawer' }),
  })
    .then(function (response) {
      if (!response.ok) {
        return response.json().then(function (error) {
          throw new Error((error && error.description) || 'No se pudo añadir el pack');
        });
      }
      return response.json();
    })
    .then(function (result) {
      renderCartDrawerSection(result, true);
      return fetch('/cart.js').then(function (r) {
        return r.json();
      });
    })
    .then(function (cart) {
      updateCartCount(cart);
      return cart;
    });
}

/**
 * "Arma tu pack" (snippets/pack-builder.liquid): recalcula el total en vivo
 * al marcar/desmarcar complementos y añade todas las líneas seleccionadas
 * al carrito con un único clic. El formato de precio replica a mano el
 * mismo patrón ya usado en initFreeShippingBar (sin acceso al filtro
 * `money` de Liquid desde JS) — asume EUR con coma decimal, igual que el
 * resto del tema.
 */
function initPackBuilder() {
  document.querySelectorAll('[data-pack-builder]').forEach(function (builder) {
    var checkboxes = builder.querySelectorAll('[data-pack-item]');
    var totalEl = builder.querySelector('[data-pack-total]');
    var savingsEl = builder.querySelector('[data-pack-savings]');
    var addButton = builder.querySelector('[data-pack-add]');
    if (!totalEl || !addButton) return;

    var mainPrice = parseInt(totalEl.getAttribute('data-main-price') || '0', 10);
    var mainSavings = savingsEl ? parseInt(savingsEl.getAttribute('data-main-savings') || '0', 10) : 0;
    var savingsTemplate = savingsEl ? savingsEl.getAttribute('data-savings-template') || '' : '';

    function formatCents(cents) {
      return (cents / 100).toFixed(2).replace('.', ',') + ' €';
    }

    function updateTotal() {
      var total = mainPrice;
      var savings = mainSavings;
      checkboxes.forEach(function (checkbox) {
        if (checkbox.checked) {
          total += parseInt(checkbox.getAttribute('data-price') || '0', 10);
          savings += parseInt(checkbox.getAttribute('data-savings') || '0', 10);
        }
      });
      totalEl.textContent = formatCents(total);

      if (savingsEl) {
        if (savings > 0) {
          savingsEl.textContent = savingsTemplate.replace('__AMOUNT__', formatCents(savings));
          savingsEl.hidden = false;
        } else {
          savingsEl.hidden = true;
        }
      }
    }

    checkboxes.forEach(function (checkbox) {
      checkbox.addEventListener('change', updateTotal);
    });
    updateTotal();

    addButton.addEventListener('click', function () {
      var items = [{ id: addButton.getAttribute('data-main-variant-id'), quantity: 1 }];
      checkboxes.forEach(function (checkbox) {
        if (checkbox.checked) {
          items.push({ id: checkbox.getAttribute('data-variant-id'), quantity: 1 });
        }
      });

      var originalText = addButton.textContent;
      addButton.disabled = true;
      addButton.textContent = addButton.getAttribute('data-loading-text') || originalText;

      addMultipleToCart(items)
        .then(function () {
          addButton.textContent = originalText;
          openCartDrawer();
        })
        .catch(function (error) {
          console.error(error);
          addButton.textContent = addButton.getAttribute('data-error-text') || originalText;
          setTimeout(function () {
            addButton.textContent = originalText;
          }, 2500);
        })
        .finally(function () {
          addButton.disabled = false;
        });
    });
  });
}

/**
 * Actualiza el contador del carrito en el header y da un pulso visual una
 * sola vez — es el único feedback fuera del propio drawer de que algo se
 * acaba de añadir. Nunca en loop, solo en el momento del cambio real.
 */
function updateCartCount(cart) {
  var cartCount = document.querySelector('[data-cart-count]');
  if (!cartCount) return;
  cartCount.textContent = cart.item_count;
  cartCount.classList.remove('is-updated');
  // Forzar reflow para poder reiniciar la animación si el usuario añade
  // dos productos seguidos antes de que termine el pulso anterior.
  void cartCount.offsetWidth;
  cartCount.classList.add('is-updated');
}

function initFreeShippingBar() {
  var bar = document.querySelector('[data-free-shipping-bar]');
  if (!bar) return;

  var threshold = parseFloat(bar.getAttribute('data-threshold') || '0');
  var current = parseFloat(bar.getAttribute('data-current') || '0');
  var progress = bar.querySelector('.cart-drawer__shipping-progress');
  var message = bar.querySelector('.cart-drawer__shipping-message');
  if (!threshold || !progress || !message) return;

  var percent = Math.min(100, (current / threshold) * 100);
  progress.style.setProperty('--progress', percent + '%');

  if (current >= threshold) {
    message.textContent = bar.getAttribute('data-reached-message') || '';
  } else {
    var remaining = (threshold - current).toFixed(2).replace('.', ',') + ' €';
    var template = bar.getAttribute('data-remaining-template') || '';
    message.textContent = template.replace('__AMOUNT__', remaining);
  }
}

/**
 * Barra fija de "Añadir al carrito" en móvil/tablet: aparece solo cuando el
 * botón real de compra sale del viewport (el cliente ha bajado a leer
 * ficha técnica, specs, FAQ...), para no obligarle a volver a subir para
 * comprar. No duplica el formulario: simplemente dispara clic sobre el
 * botón real, que ya tiene todo el flujo de validación/carrito enganchado.
 */
function initStickyBuyBar() {
  var bar = document.querySelector('[data-product-sticky-bar]');
  var realButton = document.querySelector('.product__add-to-cart');
  var stickyButton = document.querySelector('[data-product-sticky-add]');
  if (!bar || !realButton || !stickyButton) return;

  stickyButton.addEventListener('click', function () {
    realButton.click();
  });

  if (!('IntersectionObserver' in window)) return;

  var observer = new IntersectionObserver(
    function (entries) {
      bar.classList.toggle('is-visible', !entries[0].isIntersecting);
    },
    { threshold: 0 }
  );
  observer.observe(realButton);
}

/**
 * Cuentas: alterna entre el formulario de login y el de recuperar
 * contraseña sin depender del servidor — Shopify redirige a esta misma
 * URL con #recover añadido tras enviar el formulario
 * recover_customer_password, así que basta con leer el hash al cargar
 * para saber cuál mostrar por defecto (p. ej. tras un error de recuperación).
 */
function initAccountForms() {
  var loginForm = document.querySelector('[data-login-form]');
  var recoverForm = document.querySelector('[data-recover-form]');
  if (!loginForm || !recoverForm) return;

  function showRecover() {
    loginForm.hidden = true;
    recoverForm.hidden = false;
  }

  function showLogin() {
    recoverForm.hidden = true;
    loginForm.hidden = false;
  }

  document.querySelectorAll('[data-show-recover]').forEach(function (button) {
    button.addEventListener('click', function () {
      window.location.hash = 'recover';
      showRecover();
    });
  });

  document.querySelectorAll('[data-hide-recover]').forEach(function (button) {
    button.addEventListener('click', function () {
      window.location.hash = '';
      showLogin();
    });
  });

  if (window.location.hash === '#recover') showRecover();
}

/**
 * Preselecciona el país guardado en los <select> generados por
 * all_country_option_tags en las direcciones de cliente — Shopify genera
 * las <option> pero no marca ninguna como seleccionada.
 */
function initAddressCountrySelects() {
  document.querySelectorAll('select[data-default-country]').forEach(function (select) {
    var value = select.getAttribute('data-default-country');
    if (value) select.value = value;
  });
}

/**
 * "Vistos recientemente": sin app ni backend, solo localStorage. Cada PDP
 * emite su propio resumen (id/url/título/imagen/precio/badge ya
 * renderizado por Liquid) en un <script type="application/json"> — así el
 * HTML del badge sale idéntico al del resto del sitio, sin reimplementar
 * el mapeo origen→color en JS. Cualquier página con un contenedor
 * [data-recently-viewed] lo rellena al vuelo, excluyendo el producto
 * actual si estamos en su propia ficha.
 */
function initRecentlyViewed() {
  var STORAGE_KEY = 'tecnorestore:recently-viewed';
  var MAX_ITEMS = 8;

  function getStored() {
    try {
      var raw = localStorage.getItem(STORAGE_KEY);
      return raw ? JSON.parse(raw) : [];
    } catch (error) {
      return [];
    }
  }

  function setStored(items) {
    try {
      localStorage.setItem(STORAGE_KEY, JSON.stringify(items));
    } catch (error) {
      // Almacenamiento no disponible (modo privado, cuota llena...): la
      // función degrada a "no recordar nada", nunca debe romper la PDP.
    }
  }

  function escapeText(text) {
    var div = document.createElement('div');
    div.textContent = text;
    return div.innerHTML;
  }

  var currentScript = document.querySelector('[data-current-product]');
  var current = null;
  if (currentScript) {
    try {
      current = JSON.parse(currentScript.textContent);
    } catch (error) {
      current = null;
    }
  }

  if (current) {
    var items = getStored().filter(function (item) {
      return item.id !== current.id;
    });
    items.unshift(current);
    setStored(items.slice(0, MAX_ITEMS));
  }

  var mounts = document.querySelectorAll('[data-recently-viewed]');
  if (!mounts.length) return;

  var toShow = getStored().filter(function (item) {
    return !current || item.id !== current.id;
  });
  if (!toShow.length) return;

  mounts.forEach(function (mount) {
    var list = mount.querySelector('[data-recently-viewed-list]');
    if (!list) return;

    list.innerHTML = toShow
      .slice(0, 4)
      .map(function (item) {
        return (
          '<a class="recently-viewed__item" href="' + item.url + '">' +
          '<span class="recently-viewed__image">' +
          (item.image ? '<img src="' + item.image + '" alt="" width="150" height="150" loading="lazy">' : '') +
          '</span>' +
          '<span class="recently-viewed__info">' +
          (item.badgeHtml || '') +
          '<span class="recently-viewed__title">' + escapeText(item.title) + '</span>' +
          '<span class="recently-viewed__price">' + escapeText(item.price) +
          (item.savingsPercent > 0 ? ' <span class="price__savings">-' + item.savingsPercent + '%</span>' : '') +
          '</span>' +
          '</span>' +
          '</a>'
        );
      })
      .join('');
    mount.hidden = false;
  });
}

/**
 * Inclinación 3D sutil al pasar el ratón por un grupo reducido y deliberado
 * de tarjetas (categorías de home). Solo transform (composited, sin
 * relayout) y solo en dispositivos con puntero fino — en touch no se
 * activa nunca, porque una inclinación que no responde al dedo se siente
 * rota, no elegante.
 */
function initCardTilt() {
  var cards = document.querySelectorAll('[data-tilt]');
  if (!cards.length) return;
  if (!window.matchMedia('(hover: hover) and (pointer: fine)').matches) return;
  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

  var MAX_DEG = 7;

  cards.forEach(function (card) {
    var raf = null;

    card.addEventListener('pointermove', function (event) {
      if (raf) return;
      raf = requestAnimationFrame(function () {
        raf = null;
        var rect = card.getBoundingClientRect();
        var x = (event.clientX - rect.left) / rect.width - 0.5;
        var y = (event.clientY - rect.top) / rect.height - 0.5;
        card.style.transform =
          'perspective(700px) rotateX(' + (-y * MAX_DEG).toFixed(2) + 'deg) rotateY(' +
          (x * MAX_DEG).toFixed(2) + 'deg) translateY(-3px)';
      });
    });

    card.addEventListener('pointerleave', function () {
      if (raf) cancelAnimationFrame(raf);
      raf = null;
      card.style.transform = '';
    });
  });
}

/**
 * Estados (Home) — pestañas 01-04 con indicador deslizante y crossfade,
 * igual que el sistema aprobado (figma-home-repro.html). Cada panel ya
 * viene renderizado por Liquid con datos reales (foto, precio, ahorro);
 * el JS solo alterna cuál se ve — no reconstruye contenido en cliente,
 * así que no hay nada que sincronizar con datos que ya no existan.
 */
function initStatesTabs() {
  var root = document.querySelector('[data-states-tabs]');
  if (!root) return;

  var tabs = Array.prototype.slice.call(root.querySelectorAll('[data-state-tab]'));
  var panels = Array.prototype.slice.call(root.querySelectorAll('[data-state-panel]'));
  var indicator = root.querySelector('[data-state-indicator]');
  var prevBtn = root.querySelector('[data-state-prev]');
  var nextBtn = root.querySelector('[data-state-next]');
  if (!tabs.length || !panels.length) return;

  var current = tabs.findIndex(function (t) { return t.classList.contains('is-active'); });
  if (current < 0) current = 0;
  var busy = false;

  function moveIndicator(tab) {
    if (!indicator) return;
    indicator.style.width = tab.offsetWidth + 'px';
    indicator.style.transform = 'translateX(' + tab.offsetLeft + 'px)';
  }

  function show(index) {
    if (busy || index === current || index < 0 || index >= tabs.length) return;
    busy = true;

    var outgoing = panels[current];
    tabs[current].classList.remove('is-active');
    tabs[index].classList.add('is-active');
    moveIndicator(tabs[index]);

    outgoing.classList.add('is-switching');
    window.setTimeout(function () {
      panels.forEach(function (p, i) { p.hidden = i !== index; });
      panels[index].classList.remove('is-switching');
      // Un frame antes de quitar la clase de salida del panel entrante:
      // así el navegador registra el estado "recién mostrado, opacidad 0"
      // antes de animar a opacidad 1 — sin esto no habría transición.
      panels[index].classList.add('is-switching');
      requestAnimationFrame(function () {
        panels[index].classList.remove('is-switching');
      });
      current = index;
      busy = false;
    }, 220);
  }

  tabs.forEach(function (tab, i) {
    tab.addEventListener('click', function () { show(i); });
  });
  if (prevBtn) prevBtn.addEventListener('click', function () { show((current - 1 + tabs.length) % tabs.length); });
  if (nextBtn) nextBtn.addEventListener('click', function () { show((current + 1) % tabs.length); });

  window.addEventListener('load', function () { moveIndicator(tabs[current]); });
  window.addEventListener('resize', function () { moveIndicator(tabs[current]); });
}

/**
 * Compra individual / compra por lote (bulk-order-selector.liquid). El
 * bloque no decide nada por sí mismo: solo sincroniza la cantidad elegida
 * con el input real del formulario de compra (data-quantity-input) para
 * que "Añadir al carrito" siga siendo el único botón que compra, en modo
 * individual o en modo lote. En modo lote se oculta el selector +/- normal
 * (la cantidad la fija el desplegable de lote, no el usuario a mano) y se
 * restaura al volver a "Compra individual".
 */
function initBulkOrderSelector() {
  document.querySelectorAll('[data-bulk-order]').forEach(function (bulkOrder) {
    var form = bulkOrder.closest('form');
    if (!form) return;

    var quantityInput = form.querySelector('[data-quantity-input]');
    var quantitySelector = form.querySelector('[data-quantity-selector]');
    var modeInputs = bulkOrder.querySelectorAll('[data-bulk-mode-input]');
    var quantityWrap = bulkOrder.querySelector('[data-bulk-quantity-wrap]');
    var quantitySelect = bulkOrder.querySelector('[data-bulk-quantity-select]');
    if (!quantityInput || !modeInputs.length) return;

    function applyMode() {
      var mode = bulkOrder.querySelector('[data-bulk-mode-input]:checked');
      var isBulk = mode && mode.value === 'lote';

      if (quantityWrap) quantityWrap.hidden = !isBulk;
      if (quantitySelector) quantitySelector.hidden = isBulk;

      if (isBulk && quantitySelect) {
        quantityInput.value = quantitySelect.value;
      } else {
        quantityInput.value = 1;
      }
      quantityInput.dispatchEvent(new Event('change', { bubbles: true }));
    }

    modeInputs.forEach(function (input) {
      input.addEventListener('change', applyMode);
    });
    if (quantitySelect) {
      quantitySelect.addEventListener('change', applyMode);
    }

    applyMode();
  });
}
